
import Components from "slotworks/components/components";
import Translations from "slotworks/i18n/translations";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import State from "slotworks/state-machine/states/state";

export default class Recover extends State {
    public onEnter() {
        const contents = new Map<string, string>();
        contents.set("body", Translations.get("rec.fre"));

        Components.prompt.show(["info", "error"], contents).then(() => this.complete());

        const betMenuMeditaor = new BetMenuMediator();
        betMenuMeditaor.start().execute();
        betMenuMeditaor.end();
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/state-machine/standard/states/recover.ts